import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../globals/dictionary'
import { SellVariableModelType } from '@teinor/erp/types/company/config/sellVariable'

export interface SellVariablesAction {
    type: 'CHANGE_SELLVARIABLE'
    payload: SellVariableModelTypeExt[]
}
export type SellVariablePayload = { [id: string]: SellVariableModelTypeExt } | null

interface SellVariableModelTypeExt extends SellVariableModelType {
    extraDataParsed: TwinDictionary
}

export default function sellVariables(state: SellVariablePayload = null, action: SellVariablesAction): SellVariablePayload {
    switch (action.type) {
        case 'CHANGE_SELLVARIABLE':
            const sellVariables = dictionaryComplexFromJsonArr(action.payload || [], undefined, undefined, undefined, (item: any) => {
                item.extraDataParsed = JSON.parse(item.extraData || '{}')
                return item
            })
            return state = sellVariables
        default:
            return state
    }
}